import axios from 'axios'
import constants from '../../config'
import Form from '../../plugins/Form';
import Vue from 'vue'

let emptyForm = new Form({})

const state = {
  storeStep1Status: null,
  storeStep1Errors: emptyForm.errors,

  storeStep4Status: null,
  storeStep4Errors: emptyForm.errors,
}

// getters
const getters = {
  storeStepStatus: (state) => (step) => {
    return state[`storeStep${step}Status`]
  },

  storeStepErrors: (state) => (step) => {
    return state[`storeStep${step}Errors`]
  }
}

// actions
const actions = {
  storeStepData({commit, state}, formData) {
    let form = new Form(formData)
    let endpoint = `upgrade-account/step-${formData.step}`
    let requestType = 'put'

    return form.submit(requestType, constants.BASE_URL + endpoint)
      .then((resp) => {
        commit('setStoreStepStatus', {'status': 'success', 'step': formData.step})
        commit('setStoreStepErrors', {'errors': form.errors, 'step': formData.step})
      })
      .catch((resp) => {
        commit('setStoreStepStatus', {'status': 'failed', 'step': formData.step})

        if (form.errors.any()) {
          commit('setStoreStepErrors', {'errors': form.errors, 'step': formData.step})
        } else {
          let internalError = {internalError: true}

          form.errors.record(internalError)
          commit('setStoreStepErrors', {'errors': form.errors, 'step': formData.step})
        }
      })
  },
}


// mutations
const mutations = {
  setStoreStepStatus (state, data) {
    state[`storeStep${data.step}Status`] = data.status
  },

  setStoreStepErrors (state, data) {
    state[`storeStep${data.step}Errors`] = data.errors
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}